import React from "react";

const Disclaimer = ({data}) => {
  return (
    <div className="disclaimer-section mt-4" id="disclaimer-section">
      <h1 className="desc-title">Disclaimer</h1>
      <div className="disclaimer-description">
        {data?.detail}
      </div>
    </div>
  );
};

export default Disclaimer;
